import { Dispatch, SetStateAction, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { Button } from '../../../components/common/Button/Button';
import { Box, Flexed } from '../../../styles/GlobalComponents';

import { Icon, IconFlipme, IconWithdrawNFT } from '../../../styles/Icons';
import { RedeemFlipmeCardsStepsEnum } from './types';
import { P1, P2, P3 } from '../../../styles/FontStyles';

import { InputBackOffice } from '../../../components/common/InputBackoffice';
import { redeemFlipmeCard } from '../../FlipMeWallet/FlipMeWallet.actions';
import Spinner from '../../../components/common/Spinner';

interface Step2Props {
  setRedeemFlipmeCardsStep: Dispatch<
    SetStateAction<RedeemFlipmeCardsStepsEnum>
  >;
  setRedeemCardsModal: Dispatch<SetStateAction<boolean>>;
  walletAddress: string;
  setWalletAddress: Dispatch<SetStateAction<string>>;
  packageId: number | null | undefined;
}

export const Step2 = ({
  setRedeemFlipmeCardsStep,
  setRedeemCardsModal,
  walletAddress,
  setWalletAddress,
  packageId
}: Step2Props) => {
  const dispatch = useAppDispatch();

  const { loadingRedeemFlipmeCards } = useAppSelector((state) => state.wallets);

  return (
    <>
      {loadingRedeemFlipmeCards ? (
        <Spinner />
      ) : (
        <>
          {' '}
          <Flexed column center>
            <Icon>
              <IconFlipme />
            </Icon>

            <P2 bold mt='30' mb='30' center>
              Enter Flipme wallet address you want to send the activation
            </P2>

            <P3 mb='10' bold>
              Flipme wallet address:
            </P3>
            <InputBackOffice
              placeholder={'Enter wallet adress here'}
              style={{ marginBottom: 30 }}
              value={walletAddress}
              onChange={(e: string) => setWalletAddress(e)}
            />
          </Flexed>
          <Flexed>
            <Button
              mt='10'
              mr='10'
              negative
              onClick={() => setRedeemCardsModal(false)}>
              Cancel
            </Button>
            <Button
              mt='10'
              ml='10'
              disabled={walletAddress === ''}
              onClick={() => {
                dispatch(
                  redeemFlipmeCard({
                    userPackageId: packageId,
                    walletAddress,
                    setRedeemFlipmeCardsStep
                  })
                );
              }}>
              Activate
            </Button>
          </Flexed>
        </>
      )}
    </>
  );
};
